export default __webpack_public_path__ + "static/media/s1.68b30437.png";